import {
  FirstPageInfoItem,
  ImOptionConfig,
  MessageMap,
  requestData,
  requestPayload,
  requestType,
  responseData,
  responsePayload
} from '../interfaces/websocketMessageInterfaces';

import urlConfig from "@/Configurations/urlConfig";
import { Toast } from 'vant'


function debounce(fn: Function, timeout: number) {
  let timerid = 0;
  return (param: object) => {
    clearTimeout(timerid);
    timerid = setTimeout(() => {
      fn(param);
    }, timeout);
  };
}

class websocketMessageModule {
  public webSocketInstance!: WebSocket;
  private timerId: any = null;
  private options!: ImOptionConfig;
  private isImSystemLogin: boolean = false;
  private messageCacheQueue: Array<requestData<any>> = [];
  public loginParam?: requestPayload.login;
  public readonly messageMap: MessageMap = {};
  public firstPageInfoList: Array<FirstPageInfoItem> = [];
  private friendTotal: number = 0;
  private tempWebsocketConfig:any = null;


  private myLogin = debounce((param: any) => {
    return this.webSocketInstance.send(JSON.stringify(param));
  }, 0);

  private generateUniqueCode(): number {
    return Number(String(Math.random()).split('.')[1]);
  }

  private queryDataMaker(type: requestType, param: any): requestData<any> {
    return {
      requestType: type,
      uniqueCode: this.generateUniqueCode(),
      payload: param
    };
  }

  /**
   * 发送消息
   * @param param
   * @param isNeedSetMap
   */
  private sendMessage(param: requestData<any>, isNeedSetMap: boolean = true) {
    isNeedSetMap && this.messageMapSetter(param);
    if (this.webSocketInstance.readyState === 1) {
      if (param.requestType !== requestType.login) {
        if (this.isImSystemLogin) {
          this.webSocketInstance.send(JSON.stringify(param));
        } else {
          if (param.requestType === 3) {
            this.messageCacheQueue.push(param);
          }
        }
      } else {
        this.myLogin(param);
      }
    } else {
      if (param.requestType === 3) {
        this.messageCacheQueue.push(param);
      }
    }
  }

  constructor(options: ImOptionConfig) {
    this.options = options;
    window.wsIMModule = this;
    if(urlConfig.imopen == true){
      this.init(options);
    }
  }

  init(optionsa?: ImOptionConfig) {
    const options = optionsa || this.options || {};
    this.tempWebsocketConfig = options;
    if (!this.webSocketInstance) {
      this.webSocketInstance = new WebSocket(options.url || urlConfig.websocketIMModuleRequestUrl);
    } else {
      // if (this.webSocketInstance.readyState === 3) {
      //   this.webSocketInstance = new WebSocket(options.url || testUrl);
      // }
    }

    // 映射基础 websocket 事件挂钩
    this.webSocketInstance.onopen = event => {
      console.log('websocketMessage: IM websocket module connected.');
      if (options.onOpen && typeof options.onOpen === 'function') {
        options.onOpen(event);
      }
      clearInterval(this.timerId)
      this.messageMapCheckRunner();
    };

    this.webSocketInstance.onmessage = MessageEvent => {
      if (options.onMessage && typeof options.onMessage === 'function') {
        options.onMessage(MessageEvent);
      }
      this.responseMessageHandler(JSON.parse(MessageEvent.data) as responseData<any>);
    };

    this.webSocketInstance.onerror = event => {
      console.error('websocketMessage.ts: IM websocket connection error. ');
      if (options.onError && typeof options.onError === 'function') {
        options.onError(event);
      }
      setTimeout(() => {
        this.init(this.tempWebsocketConfig); // 断点重连
        this.myLogin(this.queryDataMaker(requestType.login, this.loginParam));
      }, 1000)
    };

    this.webSocketInstance.onclose = closeEvent => {
      console.log('websocketMessage: IM websocket connection closed. ');
      if (options.onClose && typeof options.onClose === 'function') {
        options.onClose(closeEvent);
      }
      setTimeout(() => {
        this.webSocketInstance.close();
        // @ts-ignore
        this.webSocketInstance = null;
        this.init(this.tempWebsocketConfig); // 断点重连
        console.log('webSocketInstance.onclose setTimeout  10000');
        this.myLogin(this.queryDataMaker(requestType.login, this.loginParam));
      }, 1000)
    };
  }

  private messageMapCheckRunner() {
    // 模拟进程 持续跑
    this.timerId = setInterval(() => {
      this.messageMapChecker();
    }, 10000);
  }

  private messageMapChecker() {
    this.ping();
    for (let messageMapKey in this.messageMap) {
      if (new Date().getTime() - this.messageMap[messageMapKey].createTime > 25000) {
        this.sendMessage(this.messageMap[messageMapKey].messageData, false);
      }
    }
  }

  private messageMapSetter(param: requestData<any>) {
    this.messageMap[String(param.uniqueCode)] = {
      createTime: new Date().getTime(),
      messageData: param
    };
  }

  private removeMessageMapItem(id: string) {
    this.messageMap.hasOwnProperty(id) && delete this.messageMap[id];
  }

  /**
   * 建立起对应关系
   * @param res
   */
  private responseMessageHandler(res: responseData<any>) {
    this.removeMessageMapItem(String(res.uniqueCode));
    if (true) {
      // @ts-ignore
      switch (res.requestType) {
        case requestType.ping:
          this.handlePing(res);
          break;
        case requestType.login:
          this.handleLogin(res.payload as responsePayload.login);
          this.onLogin && this.onLogin(res.payload.data);
          break;
        case requestType.pushMessage:
          this.handlePushMessage(res.payload as responsePayload.pushMessage);
          //处理发送后的返回值的问题
          if(res.returnCode == 201){//用户未登陆
            if(res.returnMsg.indexOf("不属于群组") != -1){
              Toast('对方已经拒收！');
            }else if(res.returnMsg.indexOf("已经被对方屏蔽了") != -1){
              Toast('对方已经拒收！');
            }else{
              //这里消息就是发送失败的
              this.login(this.loginParam);
              console.log('断开重联之后，重新初始化处理');
            }
          }else{
            this.onSendResponeUniqueCode && this.onSendResponeUniqueCode(res.uniqueCode, res.returnCode);
          }
          break;
        case requestType.getMessage:
          this.handleGetMessage(res.payload as responsePayload.getMessage);
          this.onGetMessage && this.onGetMessage(res.payload as responsePayload.getMessage);
          break;
        case requestType.removeMessage:
          this.handleRemoveMessage(res.payload as responsePayload.removeMessage);
          break;
        case requestType.getGroupMessage:
          this.handleGetGroupMessage(res.payload as responsePayload.getGroupMessage);
          this.onGetGroupMessage && this.onGetGroupMessage(res.payload as responsePayload.getGroupMessage);
          break;
        case requestType.getGroupUserList:
          this.handleGetGroupUserList(res.payload as responsePayload.getGroupUserList);
          this.onGetGroupUserList(res.payload as responsePayload.getGroupUserList);
          break;
        default:
          throw new Error('IM websocket: error request Type when get message response, code is :' + res.requestType);
      }
    } else {
      // response error handler.
      // const errorMessage = `${requestType[res.returnCode]} error: ${res.returnMsg}`
      // if (this.options.onError && typeof this.options.onError === 'function') {
      //   this.options.onError(errorMessage)
      // } else {
      //   throw new Error(errorMessage)
      // }
    }
  }

  // 心跳响应
  handlePing(res: responseData<responsePayload.ping>) {
    if (this.messageMap[res.uniqueCode]) {
      this.removeMessageMapItem(String(res.uniqueCode));
    }
  }

  handleLogin(payload: responsePayload.login) {
    this.firstPageInfoList = payload.data;
    this.friendTotal = payload.total;
    this.isImSystemLogin = true;
    let that = this;
    setTimeout(function(){
      if (that.messageCacheQueue.length > 0) {
        that.messageCacheQueue.forEach(message => {
          that.sendMessage(message);
        });
      }
    },1000);
  }

  public onLogin!: (param: Array<FirstPageInfoItem>) => any;

  handlePushMessage(payload: responsePayload.pushMessage) {}
  handleGetMessage(payload: responsePayload.getMessage) {}
  public onGetMessage!: (param: responsePayload.getMessage) => any;
  //获取发送消息之后的回执
  public onSendResponeUniqueCode!: (uniqueCode: number, returnCode:number) => any;

  handleRemoveMessage(payload: responsePayload.removeMessage) {}
  handleGetGroupMessage(payload: responsePayload.getGroupMessage) {}
  public onGetGroupMessage!: (param: responsePayload.getGroupMessage) => any;
  handleGetGroupUserList(payload: responsePayload.getGroupUserList) {}
  public onGetGroupUserList!: (param: responsePayload.getGroupUserList) => any;
  // getGroupMenuTree(payload: requestPayload.g){}

  /**
   * 填充数据的时候，返回确认码
   * @param param
   * @returns
   */
  public pushMessage(param: requestPayload.pushMessage) {
    let dataMarker = this.queryDataMaker(requestType.pushMessage, param);
    this.sendMessage(dataMarker);
    return dataMarker.uniqueCode;
  }

  public ping() {
    // this.sendMessage(this.queryDataMaker(requestType.ping, null), false);
  }

  public login(param?: requestPayload.login) {
    if (param) {
      this.loginParam = param;
    }
    this.sendMessage(this.queryDataMaker(requestType.login, param || this.loginParam));
  }

  public getGroupMessage(param: requestPayload.getGroupMessage) {
    this.sendMessage(this.queryDataMaker(requestType.getGroupMessage, param));
  }

  public getGroupUserList(param: requestPayload.getGroupUserList) {
    this.sendMessage(this.queryDataMaker(requestType.getGroupUserList, param));
  }

  public setAlreadyRead(param: requestPayload.setAlreadyRead) {
    this.sendMessage(this.queryDataMaker(3, param));
  }
}

export default new websocketMessageModule({
  url: urlConfig.websocketIMModuleRequestUrl,
})
